import { render, staticRenderFns } from "./DiseasesCreateEdit.vue?vue&type=template&id=9aed0438"
import script from "./DiseasesCreateEdit.vue?vue&type=script&lang=js"
export * from "./DiseasesCreateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports